import { LoadablePaint } from '@confluence/loadable';

export const TeammateContentRecommendationBanner = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-TeammateContentRecommendationBanner" */ '../src/components/teammate-content-recommendation-banner/TeammateContentRecommendationBanner.tsx'
			)
		).TeammateContentRecommendationBanner,
});
